const { h, render, Component } = require('preact');

const DateTime = require('./date_time')
const Date = require('./date_input')
const Checkbox = require('./checkbox')
const Description = require('./description')
const Divider = require('./divider')
const DropDown = require('./dropdown')
const Number = require('./number')
const PhoneNumber = require('./phone_number')
const Radio = require('./radio')
const TextField = require('./text_field_line')
const TextParagraph = require('./text_paragraph')
const TextParagraphInput = require('./text_paragraph_input')
const UserContactInfo = require('./user_contact_info')
const UserIdentification = require('./user_identification')
const UserName = require('./user_name')

module.exports = {
  'text_field_line': TextField,
  'date_time': DateTime,
  'checkbox': Checkbox,
  'description': Description,
  'phone_number': PhoneNumber,
  'calendar_date': Date,
  'calendar_with_hour_slot' : DateTime,
  'date_input': Date,
  'number': Number,
  'divider': Divider,
  'radio': Radio,
  'dropdown': DropDown,
  'text_paragraph': TextParagraph,
  'text_field_paragraph': TextParagraphInput,
  'text_paragraph_input': TextParagraphInput,
  'user_contact_info': UserContactInfo,
  'user_identification': UserIdentification,
  'user_name': UserName,
  'phone' : PhoneNumber
};